import { FunnelStateEnum } from "@/__generated__/types";
import { FunnelChartState } from "@/components/Funnel/types";
import { FilterState } from "@/components/FilterSidebar/FilterState";
import { FilterInputData } from "@/components/FilterSidebar/types";
import { z } from "zod/v4";

export const FunnelPageState = z.object({
  date: z.optional(z.coerce.date()),
  compareDate: z.optional(z.coerce.date()),
  filterState: z
    .optional(FilterInputData)
    .transform((val) => val && new FilterState(val)),
  compareFilterState: z
    .optional(FilterInputData)
    .transform((val) => val && new FilterState(val)),
});

export type FunnelPageState = z.infer<typeof FunnelPageState>;

export interface User {
  communityStatus: "In Community" | "Not In Community";
  cohortYear: number;
  funnelState: FunnelStateEnum;
}

export interface FunnelPoint {
  state: FunnelStateEnum;
  value: number;
}

export interface FunnelChartData {
  inCommunity: { state: FunnelStateEnum; value: number }[];
  notInCommunity: { state: FunnelStateEnum; value: number }[];
}

export interface ChartData {
  inCommunity: FunnelPoint[];
  notInCommunity: FunnelPoint[];
}

export type ViewMode = Extract<FunnelChartState, "enrolled" | "melted">;
